import { Component, OnInit, ViewChild } from "@angular/core";
import { FormControl } from '@angular/forms';
import { MatDialogRef, MatDialog, MAT_DATE_FORMATS, DateAdapter  } from "@angular/material";
import { DistributorOrderEditFormComponent } from "./distributor-order-edit-form/distributor-order-edit-form.component";
import { DataTableComponent } from "../datatable/datatable.component";
import { AppService, APP_DATE_FORMATS, AppDateAdapter } from "../../services/app.service";
import { Datatable } from "../../models/datatable.model";
import { OrderService } from "../../services/order.service";
import { ComponentService } from '../../services/component.service';
import { Order } from "../../models/order.model";
import { SharedService } from "../../services/shared";
import { DocumentDetailComponent } from "../order/document-detail/document-detail.component";
import { MasterService } from "../../services/master.service";
import { OrderRemarkComponent } from "../order-remark/order-remark.component";
import { DistSummaryChartComponent } from "./dist-summary-chart/dist-summary-chart.component";

@Component({
  selector: 'app-distributor-order',
  templateUrl: './distributor-order.component.html',
  styleUrls: ['./distributor-order.component.scss'],
  providers: [
    {
      provide: DateAdapter,
      useClass: AppDateAdapter
    },
    {
      provide: MAT_DATE_FORMATS,
      useValue: APP_DATE_FORMATS
    }
  ]
})
export class DistributorOrderComponent implements OnInit {
  public data;
  editFormDialogRef: MatDialogRef<DistributorOrderEditFormComponent>;
  documentDialogRef: MatDialogRef<DocumentDetailComponent>;
  orderRemarkDialogRef: MatDialogRef<OrderRemarkComponent>;
  summaryFormDialogRef: MatDialogRef<DistSummaryChartComponent>;
  @ViewChild('filterStatus') filterStatus;
  translations: any = [];
  public length;
  pageIndex: Number = 0;
  pageSize: Number = 10;
  filterText: String = "";
  sortDirection: String = "asc";
  sortHeaderName: String = "OrderNo";
  sortColumnNameById: String = "Id";
  orderStatusList: any = [];

  filterDateFrom: String = "0";
  filterDateTo: String = "0";
  filterOrderStatus: String = "0";
  filterShipperOrdNo: String = "";

  filterCountryId: String = "0";
  dashboardTileStausId: Number = 0;

  date = new FormControl(new Date());
  dateTo = new FormControl(new Date());

  constructor(
    private orderService: OrderService,
    public appService: AppService,
    private datatableComponent: DataTableComponent,
    public dialog: MatDialog,
    private datatableProp: Datatable,
    public order: Order,
    private sharedService: SharedService,
    public masterService : MasterService,
    public comService: ComponentService
  ) {
    this.appService.showLoading();
    this.appService.checkSession();
    this.setPageTranslations();
  }

  ngOnInit() {
    this.bindOrderStatus();
  }

  filterOrdersChart(eleDateFrom, eleDateTo, eleStatus, eleShipperOrdNo){
    this.filterDateFrom = eleDateFrom.value;
    this.filterDateTo = eleDateTo.value;
    this.filterOrderStatus = eleStatus.value;
    this.filterShipperOrdNo = eleShipperOrdNo.value;
    this.data = [];
    this.datatableProp = new Datatable();    
    this.getOrdersSummary();
  } 
  getOrdersSummary(): void {
    //this.getAllUserSuccess(this.orderService.all());

    this.filterDateFrom = this.filterDateFrom != "" && this.filterDateFrom.length == 10 ? this.filterDateFrom.split('/').join('-') : "0";
    this.filterDateTo = this.filterDateTo != "" && this.filterDateTo.length == 10 ? this.filterDateTo.split('/').join('-') : "0";
    this.filterOrderStatus = this.filterOrderStatus != undefined && this.filterOrderStatus != "" ? this.filterOrderStatus : "0";
    this.filterShipperOrdNo = this.filterShipperOrdNo != undefined && this.filterShipperOrdNo != "" ? this.filterShipperOrdNo : "!";

    this.appService.showLoading();
    this.orderService.distSummary(this.pageIndex, this.pageSize, this.sortColumnNameById, this.sortDirection, this.filterText, this.filterDateFrom, this.filterDateTo, this.filterOrderStatus,
        this.filterShipperOrdNo,  this.filterCountryId).subscribe(
        res => this.getOrdersSummarySuccess(res),
        error => this.apiFaillure(error)
    );
  }
  getOrdersSummarySuccess(res): void {
    this.data = [];
    if (res.Status == 1) {
      
      this.data = JSON.parse(res.Data).Table;
      this.summaryFormDialogRef = this.dialog.open(DistSummaryChartComponent, {
        disableClose: true,
        data: this.data,
        panelClass: "my-dialog"
      });
      this.summaryFormDialogRef.afterClosed().subscribe(response => {
        this.appService.showLoading();
        this.data = "";
        this.getOrders();
      });
    } else if (res.Status == -1) {
      this.apiFaillure(res.Message);
    }
  }

   isNavigatedFromDashboard(){
    this.dashboardTileStausId = parseInt(sessionStorage.getItem("dashStatusId"));
    this.filterOrderStatus = new String(this.dashboardTileStausId);
    this.filterCountryId = sessionStorage.getItem("dashCountryId");
    this.filterStatus.value = this.dashboardTileStausId;
    this.getOrders();
  }

  clearDate(dtControl, dtPicker){
     dtControl.value = '';
     dtPicker._datepickerInput._value = '';
  }

  bindOrderStatus(): void {
    this.masterService
      .selectSysData("OrderStatus","")
      .subscribe(
        res => this.getOrderStatussSuccess(res),
        error => this.apiFaillure(error)
      );
  }

  getOrderStatussSuccess(res): void {
    if (res.Data != null) {
      this.orderStatusList = JSON.parse(res.Data);
      this.isNavigatedFromDashboard();
    } else {
      this.apiFaillure(res.Message);
    }
  }

  setPageTranslations() {
    this.comService.get('distOrder').subscribe((res) => {
      this.translations = JSON.parse(res['Data']); 
    });
  }

  filterOrders(eleDateFrom, eleDateTo, eleStatus, eleShipperOrdNo){
    this.filterDateFrom = eleDateFrom.value;
    this.filterDateTo = eleDateTo.value;
    this.filterOrderStatus = eleStatus.value;
    this.filterShipperOrdNo = eleShipperOrdNo.value;
    this.data = [];
    this.datatableProp = new Datatable();
    this.getOrders();
  } 
   
  getOrders(): void {
    //this.getAllUserSuccess(this.orderService.all());
    this.filterDateFrom = this.filterDateFrom != "" && this.filterDateFrom.length == 10 ? this.filterDateFrom.split('/').join('-') : "0";
    this.filterDateTo = this.filterDateTo != "" && this.filterDateTo.length == 10 ? this.filterDateTo.split('/').join('-') : "0";
    this.filterOrderStatus = this.filterOrderStatus != undefined && this.filterOrderStatus != "" ? this.filterOrderStatus : "0";
    this.filterShipperOrdNo = this.filterShipperOrdNo != undefined && this.filterShipperOrdNo != "" ? this.filterShipperOrdNo : "!";

    this.appService.showLoading();
    this.orderService
      .distOrder(
        this.pageIndex,
        this.pageSize,
        this.sortColumnNameById,
        this.sortDirection,
        this.filterText,
        this.filterDateFrom,
        this.filterDateTo,
        this.filterOrderStatus,
        this.filterShipperOrdNo,
        this.filterCountryId
      )
      .subscribe(
        res => this.getOrdersSuccess(res),
        error => this.apiFaillure(error)
      );
  }

  getOrdersSuccess(res): void {
    this.data = [];
    if (res.Status) {
      this.data = JSON.parse(res.Data).Table;
      this.datatableProp = this.appService.mapDataTablePropWithIndicators(
        this.datatableProp,
        JSON.parse(res.Data).Table1[0],
        '|D_Remark|S_Remark|'
      );
      this.datatableProp.gridControl = JSON.parse(res.Data).Table2;
      this.datatableProp.isAdd = false;
      this.datatableProp.isDelete = false;
      this.datatableProp.iscustom = true;
      this.datatableProp.columnKeyData = JSON.parse(res.Data).Table3;
      this.length = this.data.length == 0 ? 0 : JSON.parse(res.Data).Table[0].MaxRowNumber;
      this.sharedService.Data.next(this.data);
      this.appService.hideLoading();
    } else if (res.Status == -1) {
      this.apiFaillure(res.Message);
    }
    
  }
  apiFaillure(error): void {
    this.appService.showLoading();
    this.appService.showDialogue("Error", error);
  }

  openCustomsDialog(e, type) {
    this.appService.showLoading();
    var actionType = e.target.getAttribute("class");
    actionType = actionType.replace("mat-icon material-icons ", "");
    if (actionType == "Documents") {
      sessionStorage.setItem('orderId', e.currentTarget.id);
      this.orderService.select(e.currentTarget.id).subscribe(
          res => this.selectDocumentSuccess(res),
          error => this.apiFaillure(error)
      );
    } else {
      this.orderService
        .select(e.currentTarget.id)
        .subscribe(
          res => this.selectSuccess(res),
          error => this.apiFaillure(error)
        );
    }
  }

  editRecord(e): void {
    this.appService.showLoading();
    this.orderService
      .select(e.currentTarget.id)
      .subscribe(
        res => this.selectSuccess(res),
        error => this.apiFaillure(error)
      );
  }

  selectDocumentSuccess(res) {
    if (res.Status == 1) {
      this.order = JSON.parse(res.Data)[0];
      this.documentDialogRef = this.dialog.open(DocumentDetailComponent, {
        disableClose: true,
        panelClass: "my-dialog",
        data: this.order
      });
      this.documentDialogRef.afterClosed().subscribe(response => {
        this.appService.showLoading();
        this.data = "";
        this.getOrders();
      });
    } else if (res.Status == -1) {
      this.apiFaillure(res.Message);
    }
  }

  selectSuccess(res,viewMode : boolean = false): void {
    if (res.Status == 1) {
      this.order = JSON.parse(res.Data)[0];
      sessionStorage.setItem("ViewMode",viewMode.toString());
      this.editFormDialogRef = this.dialog.open(DistributorOrderEditFormComponent, {
        disableClose: true,
        data: this.order,
        panelClass: "my-dialog"
      });
      
      this.editFormDialogRef.afterClosed().subscribe(response => {
        this.appService.showLoading();
        this.data = "";
        this.getOrders();
      });
    } else if (res.Status == -1) {
      this.apiFaillure(res.Message);
    }
    //this.appService.hideLoading();
  }
  deleteRecord(e): void {
    if (typeof this.translations.hdConfirm == "undefined") {
      this.setPageTranslations();
    }
    var orderId = e.currentTarget.id;
    this.appService
      .showDialogue(
        this.translations.hdConfirm,
        this.translations.confrimMessage,
        true
      )
      .afterClosed()
      .subscribe(result => {
        if (result) {
          this.appService.showLoading();
          this.deleteConfirm(orderId);
        }
      });
  }
  deleteConfirm(userId) {
    this.orderService
      .delete(userId)
      .subscribe(
        res => this.deleteSuccess(res),
        error => this.apiFaillure(error)
      );
  }
  deleteSuccess(res) {
    if (res.Status == 1) {
      this.appService
        .showDialogue(
          this.translations.hdSuccess,
          this.translations[res.Message]
        )
        .afterClosed()
        .subscribe(result => {
          if (result) {
            this.appService.hideLoading();
            this.data = "";
            this.getOrders();
          }
        });
    } else if (res.Status == -1) {
      this.apiFaillure(res.Message);
    }
  }

 
  addRecord(): void {
    this.order = new Order();
    this.order.RegistrationDate = new Date();
    this.order.Status = 151;
    this.order.TypeId = 161;
    this.editFormDialogRef = this.dialog.open(DistributorOrderEditFormComponent, {
      disableClose: true,
      data: this.order,
      panelClass: "my-dialog"
    });
    this.editFormDialogRef.afterClosed().subscribe(response => {
      this.appService.showLoading();
      this.data = "";
      this.getOrders();
    });
  }
  getServerData(event) {
    this.datatableProp = new Datatable();
    this.pageIndex = event.pageIndex;
    this.pageSize = event.pageSize;
    this.getOrders();
  }
  applyFilter(filterValue: any) {
    this.datatableProp = new Datatable();
    this.filterText = filterValue;
    this.getOrders();
  }
  getSortedData(event) {
    this.datatableProp = new Datatable();
    this.sortColumnNameById = event.currentTarget.getAttribute("id");
    this.getOrders();
  }

  openRemarkEditor(event){
    this.orderRemarkDialogRef = this.dialog.open(OrderRemarkComponent, {
        disableClose: true,
        data: event,
        panelClass: "my-dialog"
    });

    this.orderRemarkDialogRef.afterClosed().subscribe(result => {
      this.appService.showLoading();
      this.data = "";
      this.getOrders()
    });
  }

  viewRecord(e):void{
    debugger;
    this.appService.showLoading();
    this.orderService.select(e.currentTarget.id).subscribe(
        res => this.selectSuccess(res,true),
        error => this.apiFaillure(error)
    );
  }
}



// WEBPACK FOOTER //
// D:/Keval/Project/Mindport/HRS/hantraco-app/src/app/main/content/components/distributor-order/distributor-order.component.ts